import ProgressBar from "legacy/progress_bar";
import Entities from "legacy/entities";
import CampaignPage from "legacy/campaign-page";
import Home from "legacy/home";
import Microsite from "legacy/microsite";
import Countdown from "legacy/countdown_section";
import StickyNav from "legacy/sticky_nav";
import Init from "legacy/init";
import UserSignUp from "legacy/UserSignUp";
import LoginPage from "legacy/login-page";
import FaqAccordion from "legacy/faq-accordion";

window.addEventListener("DOMContentLoaded", () => {
  ProgressBar();
  new Entities();
  new LoginPage();
  new CampaignPage();
  new Home();
  new Microsite();
  new StickyNav();
  Init();
  new UserSignUp();
  new FaqAccordion();
});
